import { render, staticRenderFns } from "./NewPaintObject.vue?vue&type=template&id=40578de2&scoped=true&"
import script from "./NewPaintObject.vue?vue&type=script&lang=js&"
export * from "./NewPaintObject.vue?vue&type=script&lang=js&"
import style0 from "./NewPaintObject.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NewPaintObject.vue?vue&type=style&index=1&id=40578de2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40578de2",
  null
  
)

export default component.exports